import { VerticalSpacing } from "../VerticalSpacing"
import { RightAlignPanel } from "../ReusableStyledComponents/RightAlignPanel";
import { V3Button } from "../Button";
import { V3ButtonColor } from "../Button/V3Button.types";
import { V3CaptionGrey35 } from "../ReusableStyledComponents/V3CaptionGrey35";
import { useRef } from "react";
import { AddContentUploadWrapper } from "./AddContentUpload.styles";
import { V3IconUpload } from "../Icons";
import { V3BodyGrey48 } from "../ReusableStyledComponents/V3BodyGrey48";

interface AddContentImageProps {
    onBackHandler: () => void,
    onFilesChoosen: (files: File[]) => void,
}

export const AddContentImage = ({ onBackHandler, onFilesChoosen }: AddContentImageProps) => {

    const inputFileRef = useRef<HTMLInputElement | null>(null);

    function handleFileSelected(selectorFiles: FileList): void {
        onFilesChoosen(Array.from(selectorFiles));
        if (inputFileRef && inputFileRef.current) inputFileRef.current.value = "";
    }

    return <>
        <VerticalSpacing bottom={24}>
            <VerticalSpacing bottom={12}>
                <V3CaptionGrey35>Upload images from your device below. You can upload multiple image files at once. PNG, JPG and GIF are supported with a max. file size of 20MB.</V3CaptionGrey35>
            </VerticalSpacing>
            <AddContentUploadWrapper
                onClick={() => inputFileRef && inputFileRef.current && inputFileRef.current.click()}
            >
                <div><V3IconUpload /></div>
                <V3BodyGrey48>Select files</V3BodyGrey48>
            </AddContentUploadWrapper>
            <input style={{ display: "none" }} type="file" ref={inputFileRef} onChange={(e: React.ChangeEvent<HTMLInputElement>) => e.target.files && handleFileSelected(e.target.files)} accept={".png,.jpg"} multiple />
        </VerticalSpacing>
        <RightAlignPanel>
            <div>
                <V3Button
                    type="button"
                    text="Back"
                    color={V3ButtonColor.secondary}
                    onClick={(e) => {
                        e.preventDefault();
                        onBackHandler();
                    }}
                />
            </div>
            <div>
                <V3Button
                    text={"Continue"}
                    onClick={async () => { }}
                />
            </div>
        </RightAlignPanel>
    </>
}